export default {"src":"/_next/static/media/closeBtnIcon.0c1de812.svg","height":18,"width":18};